export default __webpack_public_path__ + "static/media/49.78ebb3b9.png";